import http from "app/services/httpService";
import config from "config.json";
const { apiUrl } = config;
const getTransactionLogAll = async (query) => {
  const data = await http.get(
    `${apiUrl}/members/apiuser-transaction-history${query ? `?${query}` : ""}`
  );
  return data;
};
const exportLedger = async (queryString) => {
  try {
    const url = `${apiUrl}/members/apiuser-transaction-history/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};
const getAllMembers = async (searchText) => {
  //debugger;
  try {
    const url = `${apiUrl}/apipartner/search-all-apiuser${
      searchText ? `?searchText=${searchText}` : ""
    }`;
    const data = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

export { getTransactionLogAll, exportLedger, getAllMembers };
